
<block-ui>
  <div class="module-bar">
    <div class="_inner">
      <button mat-icon-button (click)="dialogRef.close()">
        <mat-icon>{{appService.backIcon}}</mat-icon>
      </button>
      <span class="title flex-grow-1">{{'my_account' | translate}}</span>
    </div>
  </div>


  <div class="module-content">
    <div class="generic-desc">{{'my_account_description' | translate}}</div>

    <div class="accordion-container spacer-bottom">
      <mat-accordion>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title class="font-bold">{{appService.translate('personal_information')}}</mat-panel-title>
          </mat-expansion-panel-header>

          <form (ngSubmit)="updateCustomer()" #accountForm="ngForm">
            <mat-form-field color="accent" appearance="outline">
              <mat-label>{{'first_name' | translate}}</mat-label>
              <input #FN="ngModel" [(ngModel)]="userDetails.FirstName" name="FirstName" matInput placeholder="{{'first_name' | translate}}" validName required>
              @if (FN.dirty && FN.errors?.nameField) {
                <mat-error>{{FN.errors.nameField | translate}}</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="accent" appearance="outline">
              <mat-label>{{'last_name' | translate}}</mat-label>
              <input #LN="ngModel" [(ngModel)]="userDetails.LastName" name="LastName" matInput placeholder="{{'last_name' | translate}}" validName required>
              @if (LN.dirty && LN.errors?.nameField) {
                <mat-error>{{LN.errors.nameField | translate}}</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="accent" appearance="outline">
              <mat-label>{{'email' | translate}}</mat-label>
              <input [(ngModel)]="userDetails.Email" name="Email" type="email" email matInput placeholder="{{'email' | translate}}" required class="ltr-field">
            </mat-form-field>

            <div class="text-far mt-4">
              <button type="submit" mat-raised-button color="accent" class="rounded" [disabled]="accountForm.pristine || !accountForm.valid">
                {{'update_account'  | translate}}
              </button>
            </div>
          </form>
        </mat-expansion-panel>


      </mat-accordion>
    </div>
  </div>
</block-ui>
